import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CrossIcon from '@material-ui/icons/Clear';
import SettingsIcon from '@material-ui/icons/Settings';
import { PromptContext, Tooltip } from '@eas/common-web';
import { useRegisterUnplanWarningPrompt } from '@modules/work-order/work-order-utils';
import { BulkOperationsContext } from './bulk-operations-context';
import {
  BULK_OPERATION_FORM_KEY_CALENDAR,
  useBulkOperationsForm,
} from './bulk-operations-form';

export default function BulkOperationsControl() {
  const { bulkEditModeOn, setBulkEditModeOn, clearSelection, selected } =
    useContext(BulkOperationsContext);

  useBulkOperationsForm();
  useRegisterUnplanWarningPrompt();

  const { testPrompt } = useContext(PromptContext);

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={bulkEditModeOn}
            onChange={() => setBulkEditModeOn(!bulkEditModeOn)}
            name="checkedB"
            color="primary"
          />
        }
        label="Hromadné akcie"
      />

      {bulkEditModeOn && (
        <ButtonGroup disabled={selected.length === 0}>
          <Tooltip title="Vybrať a aplikovať hromadnú akciu na vybrané pracovné príkazy">
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                testPrompt({
                  key: BULK_OPERATION_FORM_KEY_CALENDAR,
                  submitCallback: () => {},
                });
              }}
            >
              <SettingsIcon fontSize="small" />
            </Button>
          </Tooltip>
          <Tooltip title="Resetovať výber pracovných príkazov">
            <Button size="small" variant="outlined" onClick={clearSelection}>
              <CrossIcon fontSize="small" />
            </Button>
          </Tooltip>
        </ButtonGroup>
      )}
    </>
  );
}
